export default __webpack_public_path__ + "6af75cd8b5957edd689d1b69469fc59c.svg";